// National Stock Exchange of India: 09:15–15:30 IST, 75 five-minute bars.
import { defineMarket } from '../../market';
import data from './indices.json';

export const NSE = defineMarket({
  id: 'NSE',
  name: 'National Stock Exchange of India',
  timeZone: 'Asia/Kolkata',
  openMinute: 9 * 60 + 15,
  closeMinute: 15 * 60 + 30,
  barMinutes: 5,
  currency: 'INR',
  currencySymbol: '₹',
  locale: 'en-IN',
  volumeShape: (i, bars) => 0.65 + 1.2 * Math.exp(-i / 7) + 0.8 * Math.exp(-(bars - 1 - i) / 6),
});

export interface IndexDef {
  id: string;
  name: string;
  /** Kite tradingsymbol of the index, or null for a list with no index value (NSE F&O). */
  kite: string | null;
  members: string[];
}

/** NSE F&O plus 16 NSE indices (constituents from niftyindices.com; see scripts/update-indices.ts). */
export const NSE_INDICES: IndexDef[] = data.indices as IndexDef[];
/** Index members outside the F&O universe: [symbol, sector]. */
export const NSE_EXTRA_STOCKS = data.extra as [string, string][];
export const NSE_NAMES: Record<string, string> = data.names;
export const NSE_INDICES_GENERATED: string | undefined = data.generated;

export { FNO_UNIVERSE, SECTORS, type UniverseRow } from './universe';
